/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.BoostTimeMissionWindow, {
    height: 1000,

    animation: {
        x: { align: "center" },
        y: { align: "center", dy: 230 }
    },

    ribbon: {
        x: { align: "center", dx: 377 },
        y: { align: "center", dy: 370 }
    },

    coinsReward: {
        x: { align: "center", dx: -60 },
        y: { align: "center", dy: -240 }
    },

    buyPackButton: {
        x: { align: "center", dx: 370 },
        y: { align: "center", dy: -254 }
    }
});
